export enum TabIndex {
    AdBreaks = 0,
    Markup = 1,
    QCReport = 2,
}
